// 用户中心相关
const pricooRouter = [
  {
    path: '/pricoo-special',
    component: () => import('@/layout/default.vue'),
    children: [
      {
        path: '/commitments',
        name: 'commitments',
        component: () => import('@/views/pricoo/commitments.vue'),
        meta: {
          cnName: '承诺',
          enName: 'commitments'
        }
      },
      {
        path: '/availableOffers',
        name: 'availableOffers',
        component: () => import('@/views/pricoo/availableOffers/index.vue'),
        meta: {
          cnName: '可用优惠',
          enName: 'availableOffers'
        }
      },
      {
        path: '/aboutPricoo',
        name: 'aboutPricoo',
        component: () => import('@/views/pricoo/about/index.vue'),
        meta: {
          cnName: '关于我们',
          enName: 'aboutUs'
        }
      }
    ]
  }
]

export default pricooRouter
